import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type { UnusedSkipTokenOptions } from '@tanstack/react-query'
import type {
  GetAdditionalPointsResponse,
  GetSpecialLocationsResponse,
} from '@/types/config'
import type { HttpErrorResponse } from '@/types/error'
import type { HTTPError } from 'ky'
import { configService } from '@/services/config'

export const getAdditionalPointsQueryOptions = (
  options?: Exclude<
    UnusedSkipTokenOptions<
      GetAdditionalPointsResponse,
      HTTPError<HttpErrorResponse>,
      GetAdditionalPointsResponse,
      ReturnType<typeof queryKeys.config.additionalPoints>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.config.additionalPoints(),
    queryFn: () => configService.getAdditionalPoints(),
    ...options,
  })

export const getSpecialLocationsQueryOptions = (
  options?: Exclude<
    UnusedSkipTokenOptions<
      GetSpecialLocationsResponse,
      HTTPError<HttpErrorResponse>,
      GetSpecialLocationsResponse,
      ReturnType<typeof queryKeys.config.specialLocations>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.config.specialLocations(),
    queryFn: () => configService.getSpecialLocations(),
    ...options,
  })
